var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.currentDisturbanceIsMalfunction)?_c('MalfunctionDisturbanceInfoBox',{attrs:{"disturbance":_vm.disturbance,"paginationInfo":_vm.paginationInfo}}):(_vm.currentDisturbanceIsElevator)?_c('ElevatorDisturbanceInfoBox',{attrs:{"disturbance":_vm.disturbance,"paginationInfo":_vm.paginationInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }